module.exports = require("./fr-SN.js");